import { httpGet, httpPost, httpPut } from "../../../../Util/http";
import stripSuggestions from "../../../../Util/stripSuggestions";
import { isStringValid } from "../../../../Util/stringValidator";
import { addAlert } from "../../../../MsgNotify/msgNotifyActions";

export const UPDATE_USAGE_AMOUNT = "UPDATE_USAGE_AMOUNT";
export const updateUsageAmount = (typeOf, index, amount) => ({
  type: UPDATE_USAGE_AMOUNT,
  typeOf,
  index,
  amount,
});

export const SET_USAGE_AMOUNT_TOUCHED = "SET_USAGE_AMOUNT_TOUCHED";
export const setUsageAmountTouched = (typeOf, index) => ({
  type: SET_USAGE_AMOUNT_TOUCHED,
  typeOf,
  index,
});

export const UPDATE_USAGE_KIND = "UPDATE_USAGE_KIND";
export const updateUsageKind = (
  typeOf,
  index,
  id,
  name,
  unit,
  dataSheet,
  technicalDataSheet,
  chemDataSheet
) => {
  return (dispatch) => {
    //empty the suggestion list
    dispatch(getUsageSuggestionsSuccess([]));
    //dispatch the action
    dispatch({
      type: UPDATE_USAGE_KIND,
      typeOf,
      index,
      id,
      name,
      unit,
      dataSheet,
      technicalDataSheet,
      chemDataSheet,
    });

    if (name === "Bil" && id) {
      setTimeout(() => {
        dispatch(addKorsel(index + 1));
        dispatch(setUsageAmountTouched("materiel", index + 1));
      }, 100);
    }
  };
};

export const SET_USAGE_KIND_TOUCHED = "SET_USAGE_KIND_TOUCHED";
export const setUsageKindTouched = (typeOf, index) => ({
  type: SET_USAGE_KIND_TOUCHED,
  typeOf,
  index,
});

export const GET_USAGE_SUGGESTIONS_SUCCESS = "GET_USAGE_SUGGESTIONS_SUCCESS";
export const getUsageSuggestionsSuccess = (suggestions) => {
  suggestions.forEach((s) => {
    s.id = s.productId;
  });
  return {
    type: GET_USAGE_SUGGESTIONS_SUCCESS,
    suggestions: suggestions,
  };
};

export const getUsageSuggestions = (type, val, allTypes = false) => {
  const typer = allTypes ? "" : "&type=" + type;
  var fetchUrl =
    process.env.REACT_APP_productCatalogEndPoint +
    "api/product?search=" +
    val +
    typer +
    "&skip=0&take=15";
  return (dispatch, getState) => {
    if (!val) {
      dispatch(getUsageSuggestionsSuccess([]));
      return;
    }
    return httpGet(fetchUrl)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        let alreadyChosen = getState().dailyReportUsageReducer[type];
        var jsonReponse = stripSuggestions(json, alreadyChosen);
        dispatch(getUsageSuggestionsSuccess(jsonReponse));
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

export const addUsageForWorkplace = (workplaceId, productId, cb) => {
  var fetchUrl = `${process.env.REACT_APP_webApiEndPoint}/api/arbejdsmiljo/${workplaceId}/datasheets`;
  return () => {
    return httpPost(fetchUrl, {
      materialId: productId,
    })
      .then(() => {
        cb();
      })
      .catch((e) => {
        console.log(e);
        alert("noget gik galt");
      });
  };
};

export const ADD_EMPTY_USAGE = "ADD_EMPTY_USAGE";
export const addEmptyUsage = (typeOf) => ({
  type: ADD_EMPTY_USAGE,
  typeOf,
  usage: {
    id: null,
    name: "",
    unit: null,
    amount: 0,
    subs: []
  },
});


export const ADD_EMPTY_USAGE_SUB = "ADD_EMPTY_USAGE_SUB";
export const addEmptyUsageSub = (typeOf, id, index) => ({
  type: ADD_EMPTY_USAGE_SUB,
  typeOf,
  id,
  index
});

export const SUB_CHANGE = "SUB_CHANGE";
export const onSubChange = (typeOf, index, index2, val) => ({
  type: SUB_CHANGE,
  index,
  index2,
  typeOf,
  val
})
export const SUB_REMOVE = "SUB_REMOVE";
export const onSubRemove = (typeOf, index, index2) => ({
  type: SUB_REMOVE,
  index,
  index2,
  typeOf,
})



export const addKorsel = (index) => ({
  type: UPDATE_USAGE_KIND,
  index,
  typeOf: "materiel",
  id: "fcfb7453-829d-44ab-b3d2-11f6ef2e0e90",
  name: "Kørsel",
  unit: "Stk",
  amount: 0,
  subs: []
});

export const isUsageValid = (dispatch, getState) => {
  let usage = getState().dailyReportUsageReducer;
  let materielResult = isUsageValidHelper(usage.materiel, "materiel", dispatch);
  let materialeResult = isUsageValidHelper(
    usage.materiale,
    "materiale",
    dispatch
  );

  return materielResult && materialeResult;
};

function isUsageValidHelper(usage, type, dispatch) {
  let result = true;
  usage.forEach((u, index) => {
    if (isStringValid(u.name) && (u.id == null || u.amount < 1)) {
      dispatch(setUsageAmountTouched(type, index));
      dispatch(setUsageKindTouched(type, index));
      result = false;
    }
  });
  return result;
}

export function attemptSaveUsage(currentDailyReportId, getState, dispatch) {
  var _url =
    process.env.REACT_APP_webApiEndPoint + "api/dailyreport/materiel/registerv2";
  let usage = getState().dailyReportUsageReducer;

  let usagesToSave = filterSaveAbleUsages(
    usage.materiale.concat(usage.materiel)
  );

  console.log(usagesToSave)

  usagesToSave.forEach(usage => {
    if (usage.subs) {
      usage.subs = usage.subs.map(sub => {
        if (sub.name) {
          return sub.name
        }
        return sub
      })
    }
  })

  return httpPut(_url, {
    id: currentDailyReportId,
    materiels: usagesToSave,
  }).catch(() => {
    dispatch(addAlert("Kunne ikke gemme Materiel/Materiale."));
    throw new Error("Kunne ikke gemme Materiel/Materiale");
  });
}

function filterSaveAbleUsages(allUsage) {
  let result = [];
  allUsage.forEach((u) => {
    if (u.id) result.push(u);
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Usage/actions.js